<template>
  <li class="nav-item active">
    <router-link :to="to" class="nav-link" v-bind="$attrs">
      <div
        v-if="!nested"
        class="d-flex flex-column align-items-center justify-content-center sidenav-item__icon"
      >
        <span v-show="miniIcon" class="sidenav-mini-icon">
          {{ miniIcon }}
        </span>
        <span v-if="svgIcon" class="sidenav-mini-icon-svg">
          <i class="material-icons-outlined">{{ svgIcon }}</i>
        </span>
        <span v-if="icon || $slots.icon" class="sidenav-mini-icon-svg">
          <slot name="icon"></slot>
        </span>
        <span v-if="Number(badge) > 0" class="sidenav-badge">{{ badge }}</span>
      </div>
      <span
        :class="{
          'text-link': nested,
        }"
        class="sidenav-normal me-3 ms-3"
      >
        {{ text }}
        <slot name="label"></slot>
      </span>
    </router-link>
  </li>
</template>
<script setup>
const props = defineProps({
  to: {
    type: [Object, String],
    required: true,
  },
  icon: {
    type: Boolean,
    default: false,
  },
  svgIcon: {
    type: String,
    required: false,
  },
  miniIcon: {
    type: String,
    required: false,
  },
  text: {
    type: String,
    required: true,
  },
  nested: {
    type: Boolean,
    default: false,
  },
  badge: {
    type: [Number, String],
    default: 0,
  },
});
</script>
<style lang="scss">
.sidenav-item__icon {
  position: relative;
}
.sidenav-badge {
  position: absolute;
  bottom: -4px;
  right: -6px;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  background: #ea0606;
  color: #fff;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  line-height: 17px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.sidenav-mini-icon-svg,
.sidenav-mini-icon {
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: auto;
  padding: 3px;

  img,
  svg {
    width: 100%;
    height: 100%;
    max-width: 100%;
    object-fit: contain;
  }
}

.nav-link[aria-expanded="true"] {
  background-color: rgba(199, 199, 199, 0.2);
  & + .collapse {
    position: relative;
    padding-bottom: 8px;
    margin-bottom: 8px;
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 16px;
      width: calc(100% - 32px);
      height: 1px;
      background: #89898d;
    }
  }
}
.nav-item {
  .text-link {
    margin-left: 38px !important;
  }
}
</style>
